<template>

    <div
        v-if="notificationIsShow"
        class="relative w-full py-4 px-3 rounded shadow-lg opacity-75 hover:opacity-100"
        :class="notificationClass"
    >
        <div class="flex flex-col break-words">
            <strong v-if="data.title">
                {{ data.title }}
            </strong>
            <span v-if="data.message">
                {{ data.message }}
            </span>
        </div>
        <svg
            @click="remove"
            xmlns="http://www.w3.org/2000/svg"
            class="h-3 w-3 absolute right-2 top-2 cursor-pointer fill-current"
            viewBox="0 0 16 16"
        >
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
        </svg>
    </div>
</template>

<script>
export default {
    props: {
        index: Number,
        data: Object,
    },
    data() {
        return {
            notificationIsShow: true
        }
    },
    methods:{
        remove() {
            this.$page.props.notifications.splice(this.index, 1)
        },
        hideNotification () {
            if(this.data.timeout)
                setTimeout(() => this.remove(), this.data.timeout*1000);
        },
    },
    computed: {
        notificationClass() {
            switch(this.data.type) {
                case 'error': return ['bg-red-300', 'text-red-800'];
                case 'warning': return ['bg-yellow-300', 'text-yellow-800']
                case 'info': return ['bg-blue-300', 'text-blue-800'];
                case 'success': return ['bg-green-300', 'text-green-800'];
                default: return ['bg-gray-300', 'text-gray-800'];
            }
        },
    },
    mounted () {
        this.hideNotification();
    },
}
</script>
